import { render } from "./DropdownItem.vue?vue&type=template&id=5e75793a"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"
script.render = render

export default script